const presets = [
  ["today", "Today"], ["yesterday", "Yesterday"],
  ["last-24-hours", "Last 24 hours"], ["last-7-days", "Last 7 days"],
  ["this-month", "This month"], ["last-month", "Last month"],
  ["year-to-date", "Year to date"], ["custom", "Custom dates"],
];
// Use the browser's IANA catalog; the fallback covers the current reporting regions.
const timezones = ["UTC", ...(typeof Intl.supportedValuesOf === "function"
  ? Intl.supportedValuesOf("timeZone")
  : ["Europe/London", "Australia/Sydney", "Australia/Perth", "Australia/Brisbane",
    "Australia/Adelaide", "Australia/Darwin", "Australia/Hobart", "Australia/Melbourne",
    "Pacific/Auckland", "America/New_York", "America/Los_Angeles"])];
function localDate(value = new Date(), timezone = "UTC") {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: timezone, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date(value));
  const part = (name) => parts.find((item) => item.type === name).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}
function dateTime(value, timezone = "UTC") {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: timezone, day: "numeric", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", timeZoneName: "short",
  }).format(new Date(value));
}
function intervalLabel(period, timezone) {
  return `${dateTime(period.start_at, timezone)} – ${dateTime(period.end_at, timezone)}`;
}
function precedingInterval(period) {
  const start = Date.parse(period.start_at);
  const duration = Date.parse(period.end_at) - start;
  return { start_at: new Date(start - duration).toISOString(), end_at: period.start_at };
}
module.exports = { presets, timezones, localDate, dateTime, intervalLabel, precedingInterval };
